module.exports = __webpack_public_path__ + "img/qushi.6bdfe026.png";